
































































import { Component, Vue, Mixins } from 'vue-property-decorator';
import VueHoduCommon from "@/mixin/VueHoduCommon";

@Component({
    components: {

    }
}) export default class ManualCalendar extends Mixins(VueHoduCommon) {

    beforeCreate() : void {
        document.title = '달력 | 매뉴얼';
    }
    
    mounted() : void {
        // ware_content_ul 리스트 클릭 이벤트
        $(".ware_content_ul li a").click(function(){
            $(this).parent().parent().toggleClass("on");
            return false;
        });
    }

}

